"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyButtonComponent = void 0;
var _mui = require("@ori-ui/mui");
var _presentationProductDetail = require("@ori/presentation-product-detail");
const BuyButtonComponent = exports.BuyButtonComponent = (0, _mui.styled)(_presentationProductDetail.BuyButton)({
  minWidth: 'unset'
});
